export default __webpack_public_path__ + "static/media/thomas-jefferson.9967ac34.png";